import { QrCodeScanner, Search as SearchIcon, ChevronRight } from "@mui/icons-material"
import { Typography, Box, IconButton, InputBase, Avatar, Paper } from "@mui/material"
import { styled } from '@mui/material/styles';
import { PlacesProps } from "../../types";
import { FC, useCallback, useEffect, useState } from "react";
import EmptyView from "../common/EmptyView";
import Show from "../common/show";
import { Api, getAbbr, numberWithCommas } from "../../helpers";
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { Connect, mapDispatchToProps, mapStateToProps } from "../../Redux";
import QrScanner from "./qrScan";


interface StateProps {
    places: PlacesProps[]
    loading: boolean
    searchVal: string | null
    searching: boolean
    refreshing: boolean
    showQr: boolean
}
interface Props {
    page?: 'Home',
    loggedIn?: boolean
    setRedux?: (data: any) => void
}

export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'rgba(236, 236, 236, 1)',
    '&:hover': {
        backgroundColor: 'rgba(236, 236, 236, 2)',
    },
    marginLeft: 0,
    margin: 5,
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    right: 0,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'black',
    width: '100%',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(1)})`,
        transition: theme.transitions.create('width'),
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));


export const infoStyles = {
    marginTop: 4,
    fontSize: 16,
    display: 'flex',
    color: '#000'
}
export const labelStyles = {
    color: '#727A8A'
}
const Home: FC<Props> = ({
    page,
    loggedIn,
    setRedux
}) => {
    const [state, setState] = useState<StateProps>({
        places: [],
        loading: true,
        searching: false,
        searchVal: null,
        refreshing: false,
        showQr: false
    })
    const { places, loading, searching, searchVal, refreshing, showQr } = state
    const initiateScan = () => {
        setState({ ...state, showQr: true })
    }
    const getMyPools = ({
        searchVal,
        loadingProp
    }: any) => {
        if (loadingProp)
            setState({ ...state, [loadingProp]: true })
        const afterProps = {
            searching: false,
            loading: false,
            searchVal,
            refreshing: false
        }
        Api({
            controller: 'Users',
            action: searchVal ? 'searchAllPlaces' : 'getPlayerPools',
            searchVal
        }).then((resp: any) => {
            setState({
                ...state,
                places: resp,
                ...afterProps
            })
        }).catch(() => {
            setState({
                ...state,
                ...afterProps
            })
        })
    },
        navigate = useNavigate(),

        searchPlace = (searchVal: string) => getMyPools({ searchVal, loadingProp: 'searching' }),
        startSearch = useCallback(_.debounce(searchPlace, 1000), [])
    const onScan = (url: string) => {
        if (url) {
            Api({
                controller: 'Users',
                action: 'checkForPlace',
                qrValue: url,
            }).then((resp: any) => {
                const { error } = resp
                if (error)
                    setTimeout(() => {
                        // EventsEmit('modal', {
                        //     modal: 'showAlert',
                        //     info: {
                        //         title: 'Invalid QR',
                        //         message: error,
                        //         buttons: [
                        //             {
                        //                 text: 'I understand',
                        //                 backgroundColor: colors.main,
                        //                 color: '#fff'
                        //             }
                        //         ]
                        //     }
                        // })
                    })
                else {
                    setState({
                        ...state,
                        showQr: false
                    })
                    navigate('/tables', {
                        state: {
                            _id: resp.placeId,
                            isCustomer: true,
                            pricePerGame: resp.placeTokenPrice,
                            scanned: true
                        }
                    })
                }
            }).catch((err: any) => {
                console.log(err)
                // showHideLoader(false)
                alert(err)
            })

        }

    }
    const checkForNotifications = () => {
        Api({
            controller: 'Users',
            action: 'checkForNotifications'
        }).then((resp) => {
            if (setRedux)
                setRedux({ unViewedNotifications: resp })
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        if (!loggedIn && '1' === searchVal)
            navigate('/')
        else {
            getMyPools({})
            checkForNotifications()
            // const eventListner = Events.addEventListener('mypools', (data: any) => {
            //     switch (data.action) {
            //         case 'getMyPools':
            //             getMyPools({})
            //             break;
            //     }
            // })

            return () => {
                // Events.removeEventListener(eventListner as string)
            }
        }
    }, [])
    return (
        <Box sx={{ maxWidth: 720, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 2 }}>
                <Typography sx={{ color: '#000', fontSize: 25, fontWeight: 'bold' }}>SpotPool</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Show>
                        <Show.When isTrue={Boolean(places.length)}>
                            <Box sx={{
                                bgcolor: 'rgba(0,107,70,0.1)', color: 'primary.main', fontWeight: 700,
                                borderRadius: 5, px: 1.8, py: 0.6, fontSize: 14
                            }}>
                                {places.length} pool{places.length === 1 ? '' : 's'}
                            </Box>
                        </Show.When>
                    </Show>
                    <IconButton onClick={initiateScan} sx={{ bgcolor: 'rgba(0,107,70,0.08)', color: 'primary.main' }}>
                        <QrCodeScanner fontSize='small' />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ px: '5px' }}>
                <Search sx={{ borderRadius: 3, margin: 0 }}>
                    <SearchIconWrapper>
                        <SearchIcon sx={{ fontSize: 20, color: 'black' }} />
                    </SearchIconWrapper>
                    <StyledInputBase
                        placeholder='Search'
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={(e) => startSearch(e.target.value)}
                    />
                </Search>
            </Box>
            <Show>
                <Show.When isTrue={loading || (Boolean(searchVal) && !places.length)}>
                    <EmptyView
                        loading={loading}
                        oopTxt={page ? undefined : 'Oops!'}
                        text={page ? 'Scan to add a pool or search by place name.' : 'You have not added any pools'}
                        button={{
                            text: page ? 'Scan' : 'Add Pool',
                            onPress: initiateScan
                        }}
                        searchValue={searchVal}
                    />
                </Show.When>
                <Show.Else>
                    <Box sx={{ px: '5px', pt: 2, display: 'flex', flexDirection: 'column', gap: 1.4 }}>
                        {
                            places.map((item) => {
                                const { placeName, logo, _id, numberOfTables, pricePerGame } = item
                                return (
                                    <Paper
                                        key={_id}
                                        elevation={0}
                                        onClick={() => navigate('/tables', { state: item })}
                                        sx={{
                                            borderRadius: 3, p: 1.6, display: 'flex', alignItems: 'center', gap: 2,
                                            cursor: 'pointer', bgcolor: '#fff',
                                            border: '1px solid', borderColor: 'rgba(0,0,0,0.08)',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                            transition: 'box-shadow 0.15s, transform 0.15s, border-color 0.15s',
                                            '&:hover': { boxShadow: '0 6px 18px rgba(0,0,0,0.1)', borderColor: 'rgba(0,107,70,0.3)', transform: 'translateY(-1px)' }
                                        }}
                                    >
                                        <Show>
                                            <Show.When isTrue={Boolean(logo)}>
                                                <Avatar src={logo} variant='rounded' sx={{ height: 64, width: 64, borderRadius: 2.5 }} />
                                            </Show.When>
                                            <Show.Else>
                                                <Avatar
                                                    variant='rounded'
                                                    sx={{ height: 64, width: 64, borderRadius: 2.5, bgcolor: 'rgba(0,107,70,0.12)', color: 'primary.main', fontWeight: 700 }}
                                                >
                                                    {getAbbr(placeName)}
                                                </Avatar>
                                            </Show.Else>
                                        </Show>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography noWrap sx={{ fontWeight: 700, fontSize: 16.5, color: '#111' }}>{placeName}</Typography>
                                            <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                                                <Box sx={{ bgcolor: 'rgba(0,0,0,0.06)', color: '#444', fontWeight: 600, borderRadius: 4, px: 1.2, py: 0.4, fontSize: 13 }}>
                                                    {numberOfTables} table{numberOfTables === 1 ? '' : 's'}
                                                </Box>
                                                <Box sx={{ bgcolor: 'rgba(0,107,70,0.1)', color: 'primary.main', fontWeight: 700, borderRadius: 4, px: 1.2, py: 0.4, fontSize: 13 }}>
                                                    KES {numberWithCommas(pricePerGame)} / game
                                                </Box>
                                            </Box>
                                        </Box>
                                        <ChevronRight sx={{ color: 'text.secondary' }} />
                                    </Paper>
                                )
                            })
                        }
                    </Box>
                </Show.Else>
            </Show>
            <Show>
                <Show.When isTrue={showQr}>
                    <QrScanner
                        onClose={() => setState({ ...state, showQr: false })}
                        onScan={onScan}
                    />
                </Show.When>
            </Show>
        </Box>
    )
}

export default Connect(mapStateToProps, mapDispatchToProps)(Home)